export default {"src":"/_next/static/media/plus.10480d36.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};